<div
  class="contacts-container"
  [class.private]="contactToDisplay?.ContactTypeId === ContactHelper.CONTACT_TYPE_PRIVATE"
  [class.trade]="contactToDisplay?.ContactTypeId === ContactHelper.CONTACT_TYPE_TRADE"
  [class.planer]="contactToDisplay?.ContactTypeId === ContactHelper.CONTACT_TYPE_PLANER"
  >
  <div class="contacts-content">
    <div class="first-title" fiTranslation="REQUEST_DETAIL_APPOINTMENT_HEADLINE_CONTACT_INFORMATIONS"></div>
    <h1 class="main-title field">{{ contactToDisplay?.FirstName }} {{ contactToDisplay?.LastName }}</h1>
    <h3 class="type-row field">{{ contactToDisplay?.ContactTypeText }}</h3>

    @if (!contactToDisplay?.Anonymized && contactToDisplay?.Company || contactToDisplay?.JobTitle) {
      <div class="company-row">
        @if (!contactToDisplay?.Anonymized && contactToDisplay?.Company) {
          <div>{{ contactToDisplay?.Company }}</div>
        }
        @if (contactToDisplay?.JobTitle) {
          <div>{{ contactToDisplay?.JobTitle }}</div>
        }
      </div>
    }

    <div class="action-desktop">
      <h3 class="info-title" fiTranslation="REQUEST_DETAIL_HEADLINE_CONTACT"></h3>

      <div class="fields">
        @if (contactToDisplay?.Email && !contactToDisplay?.Email?.endsWith('@temp.finstral.com')) {
          <span
            class="info-line bold"
            #mail [isTitle]="true" fiTranslation="ALT_TEXT_CONTACT_DETAIL_EMAIL"
            matTooltip="{{mail.dataset.matTooltip}}" matTooltipPosition="below"
            matTooltipClass='tooltip-style'>
            <a class="custom-link mail"
            href="mailto: {{ contactToDisplay?.Email }}">{{ contactToDisplay?.Email }}</a>
          </span>
        } @else {
          @if (contactToDisplay?.Email) {
            <span class="info-line bold">
              <span fiTranslation="CONTACT_ERRORMSG_HEADLINE_NO_EMAIL"></span>
            </span>
          }
        }
        @if (contactToDisplay?.AdditionalEmail && !contactToDisplay?.AdditionalEmail?.endsWith('@temp.finstral.com')) {
          <div class="field"
            >
            <span class="field-inner">
              @if (contactToDisplay?.AdditionalEmail && !contactToDisplay?.AdditionalEmail?.endsWith('@temp.finstral.com')) {
                <span
                  class="info-line bold">
                  <a class="custom-link"
                  href="mailto: {{ contactToDisplay?.AdditionalEmail }}">{{ contactToDisplay?.AdditionalEmail }}</a>
                </span>
              }
            </span>
          </div>
        }

        @if (contactPhone) {
          <div class="field">
            @if (contactPhone) {
              <span class="field-inner"
                >
                @if (contactPhone) {
                  <span class="info-line bold" #telephone [isTitle]="true"
                    fiTranslation="ALT_TEXT_CONTACT_DETAIL_PHONE" matTooltip="{{telephone.dataset.matTooltip}}"
                    matTooltipPosition="below" matTooltipClass='tooltip-style'>
                    <a class="custom-link" href="tel: {{ contactPhone }}">{{ contactPhone }}</a>
                  </span>
                }
              </span>
            }
          </div>
        }

        @if (contactMobile) {
          <div class="field">
            @if (contactMobile) {
              <span class="field-inner">
                @if (contactMobile) {
                  <span class="info-line bold" #mobile [isTitle]="true"
                    fiTranslation="ALT_TEXT_CONTACT_DETAIL_MOBIL" matTooltip="{{mobile.dataset.matTooltip}}"
                    matTooltipPosition="below" matTooltipClass='tooltip-style'>
                    <a class="custom-link" href="tel: {{ contactMobile }}">{{ contactMobile }}</a>
                  </span>
                }
              </span>
            }
          </div>
        }
      </div>

      @if (companyContacts?.length && contactToDisplay?.Company) {
        <h3 class="info-title">
          <span [fiTranslation]="'REQUEST_DETAIL_CONTACT_OHTER_COMPANY_CONTACTS'"></span>&nbsp;{{ contactToDisplay?.Company }}
        </h3>
        <div class="contact-lines fields">
          @for (contact of companyContacts; track contact) {
            <span class="info-line bold">
              {{ contact.FirstName }} {{ contact.LastName }}
            </span>
          }
        </div>
      }

      @if (contactToDisplay?.LanguageText) {
        <h3 class="info-title" fiTranslation="FORM_HEADLINE_LANGUAGE"></h3>
        <span class="info-line">{{ contactToDisplay?.LanguageText }}</span>
      }

      @if (contactToDisplay?.Address || contactToDisplay?.ZipCode || contactToDisplay?.CountryText || contactToDisplay?.City) {
        <h3 class="info-title" fiTranslation="REQUEST_DETAIL_HEADLINE_ADDRESS"></h3>
        @if (contactToDisplay?.Address) {
          <span class="info-line">{{ contactToDisplay?.Address }} <br></span>
        }
        @if (contactToDisplay?.ZipCode || contactToDisplay?.CountryText || contactToDisplay?.City) {
          <span class="info-line">
            {{contactToDisplay?.ZipCode}} {{contactToDisplay?.City}} {{contactToDisplay?.CountryText}}
          </span>
        }
      }

    </div>
  </div>

</div>
